<template>
  <div class="card">
    <div class="card-header">
      <h6>Cambiar contraseña</h6>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col-md-6">
          <label>Contraseña actual</label>
          <input type="password" class="form-control" v-model="form.current_password">
          <label>Nueva contraseña</label>
          <input type="password" class="form-control" v-model="form.new_password">
          <label>Confirmar nueva contraseña</label>
          <input type="password" class="form-control" v-model="form.confirm_password">
          <button class="btn bg-gradient-success mt-4 w-100" @click="changePassword"> Actualizar contraseña </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";

export default {
  name: "change-password",
  data: () => ({
    form: {
      current_password: '',
      new_password: '',
      confirm_password: '',
    }
  }),
  methods: {
    async changePassword(){
      if(this.form.current_password === '' ||
          this.form.new_password === '' ||
          this.form.confirm_password === ''
      ){
        this.alert('Todos los campos son requeridos', 'error')
        return
      }
      if(this.form.new_password.length < 6){
        this.alert('La nueva contraseña debe tener al menos 6 caracteres', 'error')
        return
      }
      if(this.form.new_password !== this.form.confirm_password){
        this.alert('La nueva contraseña y su confirmación no coinciden', 'error')
        return
      }
      try {
        const {data} = await post('users/change-password', {
          current: this.form.current_password,
          new: this.form.new_password,
        })
        if(data === 200){
          this.alert('Contraseña actualizada correctamente', 'success')
          this.clearForm()
        }else if(data === 422){
          this.alert('La contraseña actual es incorrecta', 'error')
        }else{
          this.alert('No se pudo actualizar la contraseña', 'error')
        }
      } catch (e) {
        this.alert('No se pudo actualizar la contraseña', 'error')
      }
    },
    alert(html, icon){
      this.$swal({
        html,
        icon,
        timer: 2500,
        showCancelButton: false,
        showConfirmButton: false,
      });
    },
    clearForm(){
      this.form = {
        current_password: '',
        new_password: '',
        confirm_password: '',
      }
    }
  }
}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
